import { ChangeDetectorRef, Component } from '@angular/core'
import { SquidexService } from '../../../../services/squidex.service';
import { TranslateService } from '@ngx-translate/core'
import { TransferStateService, isScullyGenerated } from '@scullyio/ng-lib'
import { Subscription } from 'rxjs'
import { take } from 'rxjs/operators'
import { SwiperOptions } from 'swiper/types'

@Component({
  selector: 'flowaccount-seminar-reviews-testimonial',
  templateUrl: './seminar-reviews-testimonial.component.html',
  styleUrl: './seminar-reviews-testimonial.component.scss',
})
export class SeminarReviewsTestimonialComponent {
  public serviceList: any
  public config: SwiperOptions
  private SEMINAR_REVIEWS_KEY = 'SEMINAR_REVIEWS_KEY'
  private subscriptionService: Subscription[] = []
  constructor(
    public readonly squidexService: SquidexService,
    protected tstate: TransferStateService,
    public translate: TranslateService,
    private cdref: ChangeDetectorRef,
  ) {}
  ngOnInit(): void {
    // After scully builded
    if (isScullyGenerated()) {
      this.tstate.useScullyTransferState(this.SEMINAR_REVIEWS_KEY, this.serviceList).subscribe((data: object[]) => {
        this.serviceList = data
        this.cdref.markForCheck()
      })
    } else {
      // run every build
      this.getserviceList()
    }
    this.swiperConfig()
  }

  async getserviceList() {
    this.subscriptionService.push(
      this.squidexService
        .getContentSquidexApiOrder('seminar-reviews-testimonial')
        .pipe(take(1))
        .subscribe((data: object[]) => {
          this.serviceList = data
          this.tstate.setState(this.SEMINAR_REVIEWS_KEY, data)
          this.cdref.markForCheck()
        }),
    )
  }
  swiperConfig() {
    this.config = {
      observer: true,
      observeParents: true,
      speed: 700,
      loop: false,
      keyboard: false,
      mousewheel: true,
      scrollbar: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        clickable: true,
        dynamicBullets: true,
      },
      injectStyles: [
        `
      .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #2898cb;
        opacity: 0.4;
      }
      .swiper-pagination-bullet-active {
        opacity: 1;
      }
      `,
      ],
      slidesPerView: 'auto',
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        stopOnLastSlide: false,
        pauseOnMouseEnter: true,
      },
    }
  }
  ngOnDestroy() {
    this.subscriptionService.forEach((x) => x.unsubscribe())
  }
}
